module.exports = __webpack_public_path__ + "img/pause.ffbd84e3.svg";